import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const convertToDataTable = (data: IGetAtmModel[]): IGetAtmModel[] => {
  const dataTableData: IGetAtmModel[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllAtmModelsList = async (): Promise<IGetAtmModel[]> => {
  const response =  await axiosDefaultApi.get(`/api/AtmModels/GetAtmModels` );
  return convertToDataTable(response as unknown as IGetAtmModel[]);
};

type QueryFnType = typeof getAllAtmModelsList;

type UseGetAllAtmModelsListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllAtmModelsList = ({ config }: UseGetAllAtmModelsListOptions = {} ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllAtmModelsList'],
    queryFn: () => getAllAtmModelsList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};